import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { VariantsAmountFormInput } from './input-form.component';

export default [
    registerFormInputComponent(
        'variants-amount-form-input',
        VariantsAmountFormInput
    ),
];
